<template>
  <v-card max-width="500">
    <v-card-title :class="branch.color || colorBr" class="darken-3 white--text">
      {{ branch.BranchName }}
      <v-spacer></v-spacer>
      <!-- <v-btn icon color="white">
        <v-icon>fas fa-pen</v-icon>
      </v-btn> -->
      <EditeBranch :Branch="branch"></EditeBranch>
    </v-card-title>
    <v-card-text>
      <v-list three-line>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon
              :class="branch.color || colorBr"
              class="darken-4 white--text"
              >fas fa-igloo</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <!-- Branch Admin -->
            <v-list-item-title>{{ branch.BranchAdmin }}</v-list-item-title>
            <!-- Branch Type -->
            <v-list-item-title class="ml-2">{{
              branch.BranchType
            }}</v-list-item-title>
            <!-- Branche Address -->
            <v-list-item-title>
              {{ branch.City }}, {{ branch.country }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :loading="loading"
        small
        width="150"
        rounded
        :class="branch.color || colorBr"
        color="darken-2 white--text"
        @click="OnLogin"
        >Login <v-icon right>fas fa-sign-in-alt</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  components: {
    EditeBranch: () => import("./editeBranch"),
  },
  props: {
    branch: { type: Object, required: true },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    colorBr() {
      return this.branch.BranchType == "store" ? "teal" : "grey";
    },
  },
  methods: {
    OnLogin() {
      this.loading = true;
      this.$store
        .dispatch("INSERT_ONLY", {
          url: "/login/SuperAdmin",
          data: {
            branch: this.branch._id,
            branchName: this.branch.BranchName,
          },
        })
        .then(val => {
          this.loading = false;
          // console.log(val);
          // this.$store.commit("AdminLogout");
          this.$store.dispatch("Adminlogin", {
            token: val.data.token,
            rToken: val.data.rToken,
          });
        })
        .catch(() => {
          this.loading = false;
          // console.log(error);
        });
    },
  },
};
</script>
